import { QueryPlugin } from '../Query/plugin'
import { defaultLocales } from './constants'
import { QueryJSCodeModel } from './ViewModel'

import type { QueryPluginProps } from '../Query/plugin'
import type { RehajePlugin } from '@rehaje/core'

export interface QueryJSCodePluginProps extends QueryPluginProps {
  /**
   * 多语言设置
   *
   * @default
   * const defaultLocales = {
   *   readonly type: "类型";
   *   readonly id: "唯一标识";
   *   readonly data: "数据";
   *   readonly loading: "加载中";
   *   readonly error: "错误信息";
   *   readonly trigger: "执行";
   *   readonly triggerParams: "执行入参";
   *   readonly reset: "重置";
   *   readonly props: "属性";
   *   readonly propsScript: "执行脚本";
   * }
   */
  locales?: {
    [K in keyof typeof defaultLocales]?: string
  }
}

export class QueryJSCodePlugin implements RehajePlugin {
  constructor(public props: QueryJSCodePluginProps = {}) {
    return new QueryPlugin({
      ...props,
      locales: {
        ...defaultLocales,
        ...props?.locales
      },
      queries: {
        JSCode: QueryJSCodeModel,
        ...props?.queries
      }
    })
  }
}
